export const VIDEOS_PATH = 'admin/videos';
